<template>
  <div class="review-partner card mb-2.5">
    <div v-if="partner?.logo" class="review-partner__image">
      <img :src="partner?.logo?.data?.url" :alt="partner?.logo?.data?.alt" />
    </div>
    <div class="review-partner__content">
      <div class="review-partner__title">
        {{ $t('review.loginPage.partnerSubtitle') }}
      </div>
      <div class="review-partner__name">
        {{ $t('review.loginPage.partnerPrefix') }} {{ partner?.name }}
      </div>
    </div>
  </div>
</template>
<script setup lang="tsx">
interface Props {
  partner: {
    name: string
    logo: {
      data: {
        url: string
        alt: string
      }
    }
  }
}
defineProps<Props>()
</script>

<style scoped lang="postcss">
.card {
  @apply bg-white p-4 rounded-lg;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.review-partner {
  @apply flex gap-2.5;

  &__image {
    @apply min-w-[110px] w-[110px] h-[110px] bg-gray-300 rounded-lg;

    img {
      @apply w-full h-full object-cover rounded-lg;
    }
  }

  &__title {
    @apply mb-1.5 text-base font-semibold overflow-ellipsis overflow-hidden;
  }

  &__name {
    @apply text-sm text-gray-600;
  }
}
</style>
